<div class="prom-search prom-input-field {hasErrorClass}">
    <div class="prom-search__label-container">
        <label>
            <span class="screen-reader">{labelText}</span>
            <input
                type="text"
                id="prom-search-{id}"
                class="prom-input-field__input"
                aria-describedby="prom-search-{id}__error-message {describedBy}"
                {placeholder}
                bind:value
                {disabled}
                on:keyup
                on:focus
                on:blur
            />
        </label>
        {#if value && !disabled}
            <button
                type="button"
                aria-hidden="true"
                class="prom-search__clear"
                tabindex="-1"
                on:click={clear} >
            </button>
        {/if}
    </div>
    <div id="prom-search-{id}__error-message">
        {#if hasError && errorMessage}
            <div class="prom-error-message">{errorMessageText}</div>
        {/if}
    </div>
</div>

{#if announceResultText}
    <p class="screen-reader" aria-live="assertive">
        {resultText}
    </p>
{/if}

<script>
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    /** @type {string} */
    export let id = 'rnd' + Math.random().toString(36);
    /** @type {Boolean} */
    export let disabled = false;
    /** @type {string} */
    export let errorMessage = '';
    /** @type {Boolean} */
    export let hasError = false;
    /** @type {string} */
    export let label = '';
    /** @type {string|undefined} */
    export let placeholder = '';
    /** @type {string} */
    export let describedBy = '';
    /** @type {string} */
    export let resultText = '';
    /** @type {Boolean} */
    export let announceResultText = true;
    /** @type {string} */
    export let value = '';

    let errorMessageText;
    let labelText;

    function clear(event) {
        value = '';
        dispatch('clear', event);
    }

    $: hasErrorClass = hasError ? 'prom-input-field--has-error' : '';

    $: {
        if (!id || typeof id !== 'string') {
            console.warn('Id must be supplied');
        }

        errorMessageText = errorMessage;
    }

    $: {
        if (!label || typeof label !== 'string') {
            console.warn('Label must be supplied');
        }

        labelText = label;
    }
</script>
